import { Box } from "@mui/material";

export default function CartoonDivider() {
  return (
    <Box
      sx={{
        width: "90%",
        height: "8px",
        backgroundColor: "black",
        borderRadius: "4px",
        margin: "40px auto",
        boxShadow: "4px 4px 0px rgba(0,0,0,0.5)",
      }}
    />
  );
}
